import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { API_RAISE_CONCERN, API_SQE_RAISE_CONCERN } from "../../config/Endpoints";
import axios from "axios";
import { showError, showSuccess } from "../../v2/utils/toast.ts";
import { getUser } from "../../utils/Storage";
import { TailSpin } from "react-loader-spinner";
import { API_MY_ATTANDANCE } from "../../config/Endpoints";
import * as Yup from "yup";
import validations from "../../config/validation";
import { useSqeLabs } from "../../v2/hooks/use-sqe-labs.ts";
import {
  Modal,
  DatePicker,
  DatePickerFieldTrigger,
  TextArea,
  Button,
} from "../../v2/components/ui/index.ts";

const FORM_ID = "raise-concern-form";

const RaiseConcern = ({ open = false, onClose = () => { }, onSuccess }) => {
  const isSqeLabs = useSqeLabs();
  const [formData, setFormData] = useState({
    concernDate: "",
    reason: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const userData = JSON.parse(getUser("userData"));
  const [attendanceData, setAttendanceData] = useState(null);
  const [isAttendanceLoading, setIsAttendanceLoading] = useState(false);
  const today = new Date();
  const minDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const maxDate = new Date();

  const fetchAttendance = async (selectedDate) => {
    try {
      setIsAttendanceLoading(true);
      const dateObj = new Date(selectedDate);
      const month = dateObj
        .toLocaleString("en-US", { month: "long" })
        .toUpperCase();
      const year = dateObj.getFullYear();

      const res = await axios.get(
        `${API_MY_ATTANDANCE}?month=${month}&year=${year}&empid=${userData?.id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      const json = res.data;

      const day = dateObj.toLocaleString("en-US", { day: "2-digit" });
      const monthShort = dateObj.toLocaleString("en-US", { month: "short" });
      const weekDay = dateObj.toLocaleString("en-US", { weekday: "short" });

      const formattedDate = `${weekDay}, ${monthShort} ${day}`;

      const record = json.data.find((item) => item.date === formattedDate);

      setAttendanceData(record || null);
    } catch (error) {
      console.error(error);
      setAttendanceData(null);
    } finally {
      setIsAttendanceLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type } = event.target;

    if (type === "date") {
      setFormData((prev) => ({ ...prev, [name]: value, reason: "" }));
      setAttendanceData(null);
      setErrors((prev) => {
        if (!prev.concernDate && !prev.reason) return prev;
        const next = { ...prev };
        delete next.concernDate;
        delete next.reason;
        return next;
      });
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
      setErrors((prev) => {
        if (!prev[name]) return prev;
        const next = { ...prev };
        delete next[name];
        return next;
      });
    }
  };

  const validationSchema = Yup.object().shape({
    concernDate: Yup.string().required("Concern date is required."),
    reason: validations.COMMENT_VALIDATION.min(
      5,
      "Minimum 5 characters are required.",
    ).max(200, "Reason must not exceed 200 characters."),
  });

  useEffect(() => {
    if (formData.concernDate) {
      fetchAttendance(formData.concernDate);
    }
  }, [formData.concernDate]);

  const handleReset = () => {
    setFormData({
      concernDate: "",
      reason: "",
    });
    setAttendanceData(null);
    setIsAttendanceLoading(false);
    setIsLoading(false);
    setErrors({});
  };

  const handleClose = () => {
    handleReset();
    onClose();
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {
      await validationSchema.validate(formData, { abortEarly: false });
      setErrors({});
    } catch (validationError) {
      if (validationError.inner) {
        const fieldErrors = {};
        validationError.inner.forEach((err) => {
          fieldErrors[err.path] = err.message;
        });
        setErrors(fieldErrors);
      }
      return;
    }

    setIsLoading(true);

    try {
      const requestData = {
        concernDate: formData.concernDate + "T00:00:00",
        reason: formData.reason,
      };
      const res = await axios.post(isSqeLabs ? API_SQE_RAISE_CONCERN : API_RAISE_CONCERN, requestData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      onSuccess?.();
      handleClose();

      showSuccess(
        res.data?.message ??
          "A concern request has been successfully raised!",
      );
    } catch (e) {
      showError(
        e?.response?.data?.message ??
          "Something went wrong please try again!",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="Raise Attendance Concern"
      size="lg"
      closeOnBackdropClick={false}
      closeOnEscape={false}
      footer={
        <div className="d-flex justify-content-center gap-3 flex-wrap w-100">
          <Button
            type="submit"
            form={FORM_ID}
            variant="accent"
            disabled={isLoading}
          >
            {isLoading ? (
              <ThreeDots
                height="20"
                width="53"
                radius="9"
                color="white"
                ariaLabel="three-dots-loading"
                visible={true}
              />
            ) : (
              "Submit"
            )}
          </Button>
          <Button
            type="button"
            variant="muted-outline"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </div>
      }
    >
      <form id={FORM_ID} onSubmit={handleSubmit}>
        <div className="modal-body p-0">
          <div className="row mt-3">
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <label htmlFor="concernDate" className="has-asterisk">
                Concern Date
              </label>
            </div>
            <div className="col-md-4 ">
              <DatePicker
                id="concernDate"
                selected={
                  formData.concernDate ? new Date(formData.concernDate) : null
                }
                onChange={(date) => {
                  if (!date) return;
                  const backendValue = date.toLocaleDateString("en-CA");
                  handleInputChange({
                    target: {
                      name: "concernDate",
                      value: backendValue,
                      type: "date",
                    },
                  });
                }}
                dateFormat="MM-dd-yyyy"
                minDate={minDate}
                maxDate={maxDate}
                placeholderText="mm/dd/yyyy"
                customInput={
                  <DatePickerFieldTrigger placeholderText="mm/dd/yyyy" />
                }
                required
                error={errors.concernDate}
              />
            </div>
            <div className="col-md-2"></div>
          </div>
          {isAttendanceLoading && (
            <div className="overlay">
              <div className="loader-container">
                <TailSpin
                  height="100"
                  width="100"
                  radius="1"
                  color="blue"
                  ariaLabel="tail-spin-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            </div>
          )}

          {!isAttendanceLoading && attendanceData && (
            <div className="row mt-3">
              <div className="col-md-2"></div>
              <div className="col-md-4"></div>
              <div className="col-md-4">
                <div className="text-muted border p-2 rounded-3 attendance-info-box">
                  <p className="mb-1">
                    Punch In: {attendanceData.punch_in_time}
                  </p>
                  <p className="mb-1">
                    Punch Out: {attendanceData.punch_in_out}
                  </p>
                  <p className="mb-1">
                    Total Hours: {attendanceData.total_hour}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="row mt-3">
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <label htmlFor="raise-concern-reason" className="has-asterisk">
                Brief Reason
              </label>
            </div>
            <div className="col-md-4 ">
              <TextArea
                id="raise-concern-reason"
                name="reason"
                required
                value={formData.reason}
                onChange={handleInputChange}
                rows={3}
                error={errors.reason}
                onKeyPress={(e) => {
                  if (e.charCode === 32 && e.target.selectionStart === 0) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <div className="col-md-2"></div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default RaiseConcern;
